import { Component, Input, OnInit } from '@angular/core';
import { BookingType, PriceInBookingType } from "@afidium/ts-facade";
import { ECostOrRetail } from "../../booking-price-card.enum";
import { PricesTableService } from "../../services/prices-table.service";
import { Yii } from "../../../../../../interfaces/Yii";


export class Wording {
    public readonly iata: string = Yii.t("wui-sasha-js", "Iata : ");
    public readonly vendor: string = Yii.t("wui-sasha-js", "vendeur : ");

}

@Component({
    selector: 'tarification-header-service',
    template: `
        <div class="tarification-header-service">
            <table>
                <tr>
                    <td class="fixed">
                        <sector-detail [price]="price" [booking]="booking" [showMoreDetails]="false"></sector-detail>
                    </td>
                    <td class="fixed">
                        <div class="tarification-header__resume-column">
                            <div *ngIf="vendor; else notVendor;" class="tarification-info">
                                <span class="tarification-label">{{ wording.vendor }}</span>
                                <span class="tarification-value">{{ vendor }}</span>
                            </div>
                            <ng-template #notVendor></ng-template>

                            <div *ngIf="iata; else notTravellerSummary;" class="tarification-info">
                                <span class="tarification-label">{{ wording.iata }}</span>
                                <span class="tarification-value">{{ iata }}</span>
                            </div>
                            <ng-template #notTravellerSummary></ng-template>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    `,
    styles: [`
        table {
            border: none;
            border-collapse: unset;
        }

        .tarification-value {
            font-weight: bold;
            padding-left: .375rem;
        }

        .tarification-value, .tarification-label {
            flex-grow: 1;
            width: 50%;
        }

        .tarification-label {
            text-align: right;
        }

        .tarification-info {
            display: flex;
        }

        .fixed {
            width: 50%;
        }
    `],
    providers: [PricesTableService]
})
export class TarificationHeaderServiceComponent implements OnInit {

    @Input()
    public price: PriceInBookingType;
    @Input()
    public costOrRetail: string = ECostOrRetail.cost;
    @Input()
    public booking: BookingType;

    public wording: Wording = new Wording();
    public vendor: string;
    public iata: string;


    public constructor(
        private readonly pricesTableService: PricesTableService
    ) {
    }

    public ngOnInit(): void {
        this.vendor = this.getVendor();
        this.iata = this.getIata();
    }


    public getVendor(): string {
        return this.pricesTableService.getSingleServiceFromBooking(this.booking?.serviceArray, this.price, this.costOrRetail)?.ssr?.vendor?.iata;
    }

    public getIata(): string {
        return this.pricesTableService.getSingleServiceFromBooking(this.booking?.serviceArray, this.price, this.costOrRetail)?.iata;
    }
}
